<div class="dialog">
  <div id="box-file-picker"></div>
</div>
